export default "/_next/static/images/service-recurring-3x-fcb33aed9655abb6c9941453d432ae6f.png";